<template>
    <svg t="1566617448833" class="icon" viewBox="0 0 1024 1024" version="1.1" p-id="1462" width="200" height="200">
        <path d="M810.666667 853.333333H213.333333a42.666667 42.666667 0 0 0 0 85.333334h597.333334a42.666667 42.666667 0 0 0 0-85.333334z m-328.96-97.706666a42.666667 42.666667 0 0 0 14.08 8.96 40.106667 40.106667 0 0 0 32.426666 0 42.666667 42.666667 0 0 0 14.08-8.96l170.666667-170.666667a42.666667 42.666667 0 0 0-60.586667-60.586667L554.666667 622.506667V128a42.666667 42.666667 0 0 0-85.333334 0v494.506667l-97.706666-98.133334a42.666667 42.666667 0 1 0-60.586667 60.586667z" p-id="1463" fill="#808080">
        </path>
    </svg>
</template>

<script>
export default {
  name: 'ArrowBottomIcon',
  components: {
  },
  created() {
  }
}
</script>
